var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"name":_vm.name || _vm.label,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var classes = ref.classes;
var required = ref.required;
return [(_vm.label)?_c('label',{class:[required && 'required', _vm.labelClass]},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._t("default"),_c('span',{class:classes},[_vm._v(_vm._s(errors[0]))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }